import PropTypes from 'prop-types';
import React, {useState} from 'react';

import {LOAD_BAR} from '../../../constants/loadBar';
import {TYPE_CLICK} from '../../../constants/tagManager';
import {CNPJ_TYPES} from '../../../constants/typesMessages';
import {
  pushInteractionTagManagerChatbot,
  pushNoInteractionTagManagerChatbot
} from '../../../services/tagManager';
import {HideButtonWhenLogout} from '../../../shared/components/HideButtonWhenLogout';
import {useChatStore} from '../../../store/slices/chatStore';

const MessageCnpjNoInfoBureauConfirme = (props) => {
  const setMessages = useChatStore((state) => state.setMessages);
  const setChatStageFlow = useChatStore((state) => state.setChatStageFlow);
  const responseTypeChange = useChatStore((state) => state.responseTypeChange);
  const responseFlowChange = useChatStore((state) => state.responseFlowChange);
  const [hiddenButtons, setHiddenButtons] = useState('');

  const cnpjWithoutInfoBureauRight = () => {
    setHiddenButtons('hidden');
    pushInteractionTagManagerChatbot({
      ...TYPE_CLICK,
      elementContent: 'step-8:none:cnpj-correto'
    });

    let newMessages = [
      {
        text: 'Sim',
        edit: 'buttons-cnpj-confirme-no-info-bureau',
        type: 'response-sent'
      },
      {
        text: 'Os dados da sua empresa mudaram? Não se preocupe, faça uma atualização junto à Receita Federal e volte aqui no chat para atualizarmos seu cadastro, tá bem?',
        type: 'message-receive'
      },
      {
        text: 'Tudo bem, então vamos cadastrar todas a informações',
        type: 'message-receive'
      },
      {
        text: 'Me diga, qual é a Razão Social da sua empresa?',
        type: 'message-receive'
      }
    ];
    setMessages(newMessages);
    setChatStageFlow(LOAD_BAR.CNPJ);
    responseTypeChange('informations-cnpj-legal-name');
    pushNoInteractionTagManagerChatbot({
      elementContent: 'step-9:none:razao-social'
    });
  };

  const cnpjWithoutInfoBureauWrong = () => {
    setHiddenButtons('hidden');
    pushInteractionTagManagerChatbot({
      ...TYPE_CLICK,
      elementContent: 'step-8:none:cnpj-correto'
    });

    let newMessages = [
      {
        text: 'Não',
        edit: 'buttons-cnpj-confirme-no-info-bureau',
        type: 'response-sent'
      },
      {
        text: 'Sem problemas! Basta informar o CNPJ certinho para podermos seguir.',
        type: 'message-receive'
      }
    ];
    setMessages(newMessages);
    responseTypeChange(CNPJ_TYPES.CNPJ_FLOW);
    responseFlowChange(CNPJ_TYPES.CNPJ);
  };

  return (
    <div>
      <div className="message-line">
        <div
          className="message-receive"
          id={`msg-${props.question.id}`}
          data-aut-test="message-receive-text"
        >
          <div className="message-div">{props.question.text}</div>
        </div>
      </div>
      <HideButtonWhenLogout>
        <div
          className={`message-line ${hiddenButtons}`}
          id={`button-option-cnpj-confirme-${props.question.id}`}
          data-aut-test="button-option-cnpj-confirm-no-info-bureau"
        >
          <div className="div-button">
            <button
              id="cnpj-sem-info-bureau-correto-nao"
              data-testid="cnpj-without-info-bureau-right-no"
              data-aut-test="cnpj-without-info-bureau-right-no"
              type="button"
              onClick={() => cnpjWithoutInfoBureauWrong()}
            >
              NÃO
            </button>
            <button
              id="cnpj-sem-info-bureau-correto-sim"
              data-testid="cnpj-without-info-bureau-right-yes"
              data-aut-test="cnpj-without-info-bureau-right-yes"
              type="button"
              onClick={() => cnpjWithoutInfoBureauRight()}
            >
              SIM
            </button>
          </div>
        </div>
      </HideButtonWhenLogout>
    </div>
  );
};

MessageCnpjNoInfoBureauConfirme.propTypes = {
  question: PropTypes.object
};

export default MessageCnpjNoInfoBureauConfirme;
